export default __webpack_public_path__ + "static/lenovo-ac54390d1eca5e54e8e015ea5de01d75.jpg";